export enum UrlPatternType {
	EXACT = "EXACT",
	DOMAIN = "DOMAIN",
	HOSTNAME = "HOSTNAME",
	ORIGIN = "ORIGIN",
	WILDCARD = "WILDCARD",
	REGEX = "REGEX",
	COMPOSITE = "COMPOSITE",
}

export type ExactUrlPattern = {
	type: UrlPatternType.EXACT;
	url: string | URL;
};

export type DomainUrlPattern =
	| {
			type: UrlPatternType.DOMAIN;
			url: string | URL;
			domain?: never;
	  }
	| {
			type: UrlPatternType.DOMAIN;
			url?: never;
			domain: string;
	  };

export type HostnameUrlPattern =
	| {
			type: UrlPatternType.HOSTNAME;
			url: string | URL;
			hostname?: never;
	  }
	| {
			type: UrlPatternType.HOSTNAME;
			url?: never;
			hostname: string;
	  };

export type OriginUrlPattern =
	| {
			type: UrlPatternType.ORIGIN;
			url: string | URL;
			origin?: never;
	  }
	| {
			type: UrlPatternType.ORIGIN;
			url?: never;
			origin: string;
	  };

export type WildcardUrlPattern = {
	type: UrlPatternType.WILDCARD;
	/**
	 * '?' matches any single character, '*' matches any number of characters
	 */
	pattern: string;
};

export type RegexUrlPattern = {
	type: UrlPatternType.REGEX;
	regex: RegExp | string;
};

export type CompositeUrlPattern = {
	type: UrlPatternType.COMPOSITE;
	urlPatterns: UrlPattern[];
};

export type UrlPattern =
	| ExactUrlPattern
	| DomainUrlPattern
	| HostnameUrlPattern
	| OriginUrlPattern
	| WildcardUrlPattern
	| RegexUrlPattern
	| CompositeUrlPattern;

export type UrlMatcher<T extends UrlPatternType> = {
	type: T;
	match: (url: URL | string) => boolean;
};
